<template>
	<div class="col-lg-2" style="padding-left: 0">
		<ul class="dynvibeListRulesMastertags" @click="clicked($event)">
			<li
				v-for="(item, index) in data"
				:key="index"
				:data-label-mastertag="item.data.label"
				:style="unaffectedColor(item.data.archi == undefined ? [] : item.data.archi)"
			>
				{{ item.data.label }}
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: "listmtcat",
	props: {
		type: {
			type: String,
			default: "mastertags",
		},
	},
	data() {
		return {
			data: [],
			mastertags: "",
			unaffected: false,
		};
	},
	methods: {
		clicked(event) {
			// keeping thigs reusable
			//label = event.target.attributes.getAttribute('data-label-mastertag')
			let label = event.target.attributes[0].value;
			let type = this.type;

			this.$emit("innerclick", { label: label, type: type });
		},
		unaffectedColor(params) {
			if (params != undefined && params.length == 0 && this.type == "mastertags") {
				return "color: red";
			}
		},
		unaffectedOnly() {
			if (this.type == "mastertags") {
				this.getData("onlyUnaffectedMastertag");
				this.unaffected = true;
			}
		},
		loadComponent() {
			this.getData("getListMtCat", { type: this.type });
		},
		search(value) {
			if (this.unaffected == false) {
				this.getData("getListMtCat", { type: this.type, search: value });
			} else {
				this.getData("onlyUnaffectedMastertag", { search: value });
			}
		},
		treatResponse(response) {
			this.data = response.data.data;
		},
	},
};
</script>

<style scoped>
.dynvibeListRulesMastertags {
	max-height: none;
	height: calc(100vh - 242px);
}
</style>
